<template>
  <div style="min-width:750px;height:calc(100% - 20px)" class="ml-7 mt-5">
    <p style="font-size:24px;font-weight:bold;">我的创作</p>
    <div style="display:flex;" class="mt-3 pr-5">
      <v-tabs v-model="topBarIndex" class="mainCreationManagerTopTabs">
        <v-tab v-for="(item,index) in topTabList" :key="index"
               :style="{'color':topBarIndex === index ? '#1976D2' : '#000000'}" style="font-size:20px;" class="px-0 mr-5">{{item.title}}</v-tab>
        <v-tabs-slider color="#1976D2"></v-tabs-slider>
      </v-tabs>
      <v-spacer></v-spacer>
      <v-text-field v-model="keyword" style="width:200px;margin-top:4px;" append-icon="mdi-search" height="30" dense outlined placeholder="搜索" hide-details color="#808080">
        <template v-slot:append>
          <p style="font-size:16px;font-weight:bold;color:#1E3A8A;cursor:pointer;" class="iconfontFamily mt-1">&#xe613;</p>
        </template>
      </v-text-field>
    </div>

    <div v-if="creationList.length !== 0" style="display:flex;flex-direction:column;">
      <div style="display:flex;flex-flow: wrap; " class="mt-4">
        <creation-item v-for="(item,index) in creationList" :key="index" :creationInfo="item"
                       @saveAsDraftSuccess="saveAsDraftSuccess" @deleteOKFun="deleteOKFun" class="mr-5 mb-5"></creation-item>
      </div>
      <v-spacer></v-spacer>
      <!--页码-->
      <page-number v-if="totalPageNum > 1" :totalPageNum="totalPageNum" :currPageNum="currPageNum" @changePageNumber="changePageNumber" class="mb-5"></page-number>
    </div>

    <div v-if="creationList.length === 0" style="width:100%;text-align:center;">
      <p style="margin-top:20%;font-size:68px;color:#a6a6a6;" class="iconfontFamily">&#xe618;</p>
      <p style="font-size:16px;font-weight:bold;line-height:30px;color:#a6a6a6;">暂无创作内容</p>
    </div>

  </div>

</template>

<script>
import CreationItem from '/src/components/creation_item/CreationItem';
import PageNumber from '/src/components/page_number/PageNumber';

export default {
  name: "MainCreationManage",
  components: {
    CreationItem,PageNumber
  },
  computed:{
    jumpToPageNumList(){
      let arr = [];
      for(let i=0;i<this.totalPageNum;i++){
        arr.push(i+1)
      }
      return arr;
    }
  },
  data(){
    return{
      topTabList:[
        {title:"全部创作",value:-1},
        {title:"已发布",value:1},
        {title:"审核中",value:2},
        {title:"待处理",value:-2},   //实际是后台状态的3和4，未通过+已下架
        {title:"草稿箱",value:0},
      ],
      topBarIndex:0,

      keyword:"",

      creationList:[],
      totalPageNum:0,
      currPageNum:1,

      errorCreationDialogShow:false,

    }

  },
  methods:{
    getDataList(pageNum){
      //搜索关键字，状态两个值，草稿箱只返回了一项
      this.$axios({
        method:"get",
        url:"/authorApi/main-info/getMainInfoList",
        params:{
          progressStatus:this.topTabList[this.topBarIndex].value,
          curPageNum:pageNum,
          maxResultNum:12,
          searchContent:this.keyword
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.creationList = resultData.data.mainInfoDtoList;
          this.currPageNum = pageNum;
          this.totalPageNum = resultData.data.totalPageNum;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },
    //修改页码
    changePageNumber(param){
      this.getDataList(param);
    },


    //删除成功
    deleteOKFun(){
      var index = this.creationList.findIndex(item=>{ // 根据当前项id获取当前项在数组中的索引
        return item.infoId === this.$store.state.deleteCreationId
      });
      this.creationList.splice(index,1);
      this.$store.state.deleteCreationId = "";
    },

    //另存草稿成功
    saveAsDraftSuccess(param){
      if(this.topBarIndex === -1 || this.topBarIndex === 0){
        this.creationList.unshift(param)
      }
    },



  },
  watch:{
    topBarIndex(){
      this.getDataList(1);
    },
    //搜索
    keyword(){
      this.getDataList(1)
    }
  },
  mounted(){
    this.getDataList(1)
  }
}
</script>


<style>

.mainCreationManagerTopTabs .v-tabs-bar{
  background:transparent !important;
}


</style>